<template>
  <div>
    <!--    Notification Drawer-->
    <div class="notification-wrapper">
      <div class="d-flex justify-content-between align-items-center my-4">
        <h4 class="notification-title text-left">Notification</h4>
        <span class="close" @click="toggleN">
          <font-awesome-icon icon="times"></font-awesome-icon>
        </span>
      </div>
      <!--      Loader-->
      <!--      <div class="d-flex justify-content-center mb-3">-->
      <!--        <b-spinner label="Loading..."></b-spinner>-->
      <!--      </div>-->
      <!--      Loader-->
      <div
        v-bar="{
          preventParentScroll: true,
          scrollThrottle: 30
        }"
      >
        <!-- el1 -->
        <div>
          <!-- el2 -->
          <!-- your scrollable content -->

          <div
            v-for="greetings in getNotification"
            :key="greetings.id"
            class="notification-group"
          >
            <!--<span class="time">TODAY</span>-->
            <div v-for="inx in 1" :key="inx" class="notification-item">
              <div class="cover">
                <b-img :src="greetings.imageUrl"></b-img>
              </div>
              <div class="details">
                <p class="heading p-0">{{ greetings.course_notification_model.course_name }}</p>
                <div class="bot">
                  <span class="left"
                    > {{ greetings.operation }} By Teacher</span
                  >
                  <span class="right">{{ greetings.time }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- dragger will be automatically added here -->
      </div>
      <div class="view-more">
        <span class="mr-2">View more</span>
        <font-awesome-icon icon="angle-down"></font-awesome-icon>
      </div>
    </div>
    <div class="notification-wrapper-backdrop" @click="toggleN"></div>
    <!--    Notification Drawer-->
  </div>
</template>

<script>
import { commonFunctions } from "../../Commonjs/commonFunctions";
import { mapGetters } from "vuex";
import { notifications } from "../../Commonjs/notificationjs";

export default {
  name: "notification",
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("notifications", ["getNotification"])
  },
  data() {
    return {
      notificationArray: []
    };
  },
  methods: {
    toggleN(e) {
      commonFunctions.toggleNotification(e);
    },
    messaging() {
      console.log("sending message");
      const message = "Hiii Welcome To Edfore";
      notifications.sendMessage(message);
    }
  },
  watch: {
      getNotification(){
        console.log("sfdnsdf",this.getNotification);
      }
  }
};
</script>

<style scoped></style>
